// utils/guestDisplay.js
//
// ONE answer to "how do we label a guest" — source name and value tier — for the
// guests table and the phone guest card. Both carried their own copy of these maps.

const SOURCE_LABELS = {
  direct: 'Host Me',
  airbnb: 'Airbnb',
  booking: 'Booking.com',
  expedia: 'Expedia',
  ical: 'iCal',
  gathern: 'Gathern',
  almosafer: 'المسافر',
  manual: 'يدوي',
  other: 'آخر'
};

/** Display name of a guest's acquisition source; unknown values pass through. */
export const getGuestSourceLabel = (source) => SOURCE_LABELS[source] || source;

/** Value tier by number of bookings: icon, CSS colour key and Arabic label. */
export const getGuestTier = (bookings = 0) => {
  if (bookings >= 10) return { icon: 'bi-gem', color: 'platinum', label: 'بلاتيني' };
  if (bookings >= 5) return { icon: 'bi-star-fill', color: 'vip', label: 'VIP' };
  if (bookings >= 2) return { icon: 'bi-arrow-repeat', color: 'repeat', label: 'متكرر' };
  return { icon: 'bi-person', color: 'new', label: 'جديد' };
};
